import { eArchiveApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { ProductInfoResponse } from 'src/types';

export const getProductInfo = (config: AxiosRequestConfig = {}) =>
  eArchiveApi.get<ProductInfoResponse>('/api/v1/productInfo', config);

export const updateProductDescription = (description: string) =>
  eArchiveApi.patch<void>('/api/v1/productInfo', { description });
